import { motion } from 'framer-motion';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import UserCardItem from './UserCardItem';
import Grid from '@mui/material/Grid';
import { setUserViewDialogId } from 'app/store/contactsSlice';
import { useSelector, useDispatch } from 'react-redux';


function UserList(props) {
  const { users, emptyMessage, onClickBasePath, onClick, singleColumn, providerView,
         searchResults, menu, menuProps, forceId, fetchedAll, fetchMore} = props;
  const dispatch = useDispatch();
  const clickHandler= onClick ? onClick : onClickBasePath ? undefined : onUserClick;
  const userCount= users ? users.length : 0;
  const displayFetchMore= !fetchedAll && fetchMore && userCount > 1;
  
 
  function onUserClick(id) {
      dispatch(setUserViewDialogId(id));
  }
  
  if (!users) {
    return null;
  }

  if (users.length === 0) {
    return (
	     <>
		   <div className="flex flex-1 w-auto justify-center items-top space-x-12">
	        <Typography color="text.secondary" variant="h5">
	          { emptyMessage}
	        </Typography>
	       </div>
		 </>
    );
  }

  return (
      <>
      <motion.div
	      initial={{ y: 20, opacity: 0 }}
	      animate={{ y: 0, opacity: 1, transition: { delay: 0.2 } }}
	      className="flex flex-col flex-auto w-full max-h-full pr-16"
	    >
            <Grid container spacing={2} alignItems="stretch" className="w-full m-0 p-0">
              {users.map((user) => (
				        <Grid key={user.id} item xs={12} sm={singleColumn ? 12 : 6} md={singleColumn ? 12 : 4}>
               		 <UserCardItem  user={user} onClickBasePath={onClickBasePath} onClick={clickHandler}
               		                menu={menu} menuProps={menuProps} providerView={providerView} 
               		                searchResult={searchResults} forceId={forceId}/>
                </Grid>
              ))}
            </Grid>
            
            {displayFetchMore && (
			      <div className="flex flex-row w-full justify-center mt-20 mb-20">
	            <Button variant="contained" color="secondary" size="small" 
	                    aria-label="fetchMore" onClick={fetchMore}>
	              Fetch More
	            </Button>
	          </div>
		        )}
            
	    </motion.div>
    </>
  );
}

export default UserList;
